import { Text as CText } from '@chakra-ui/react';

const Text = ({ family, sx, size, bold, color, children, label, ...props }) => (
	<CText
		fontFamily={family}
		color={color || 'primary'}
		fontWeight={bold && 'bold'}
		fontSize={sx || size}
		{...props}
	>
		{children || label}
	</CText>
);

const NutmegRegular = (props) => <Text family="Nutmeg Regular" {...props} />;
const NutmegBold = (props) => <Text family="Nutmeg Bold" {...props} />;

const PoppinsRegular = (props) => <Text family="Poppins Regular" {...props} />;
const PoppinsBold = (props) => <Text family="Poppins Bold" {...props} />;
const PoppinsMedium = (props) => <Text family="Poppins Medium" {...props} />;
const PoppinsSemiBold = (props) => (
	<Text family="Poppins SemiBold" {...props} />
);

export {
	NutmegRegular,
	NutmegBold,
	PoppinsMedium,
	PoppinsRegular,
	PoppinsSemiBold,
	PoppinsBold
};
